(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["awb-catalog-collection"] && !Shopify.designMode) return;
  try {
    
  function awbUsSize(name, value) {
    const s = value.toUpperCase().replace(/’/g, "'").trim();
    const prefix = s.match(/(?:^|[^A-Z])US\s*(?:(?:WOMEN|MEN)(?:'S|S)?\s*)?(\d+(?:\.\d+)?)(?:\s*(?:EEE|EE|EW|WIDE|MEDIUM|M|W|D|B))?(?=$|[\s/(])/);
    const suffix = s.match(/(?:^|[^\d.])(\d+(?:\.\d+)?)\s*(?:EEE|EE|EW|WIDE|MEDIUM|M|W|D|B)?\s*US(?=$|[^A-Z])/);
    if (prefix || suffix) return Number((prefix || suffix)[1]);
    if (/\bUS\b/i.test(name) && !/UK|AU|EU/i.test(name + ' ' + s) && /^\d+(\.\d+)?(?:\s*(?:M|W|EE|WIDE|MEDIUM))?$/.test(s)) return parseFloat(s);
    return null;
  }
  function setupAwbShop() {
    document.querySelectorAll('[data-awb-shop]').forEach(shop => {
      if (shop.dataset.ready || shop.dataset.landing === 'true') return;
      shop.dataset.ready = 'true';
      const grid = shop.querySelector('.awb-product-grid');
      const buttons = [...shop.querySelectorAll('[data-size]')];
      const results = shop.querySelector('[data-results]');
      const empty = shop.querySelector('[data-empty]');
      const nav = shop.querySelector('[data-pages-nav]');
      const error = shop.querySelector('[data-load-error]');
      const initial = shop.cloneNode(true);
      const pageSize = 12;
      let products = [], loaded = false, selection = 'all', currentPage = 1;
      function readLocation() {
        const url = new URL(location.href);
        selection = url.searchParams.get('awb_size') || 'all';
        if (selection === '14+' && !buttons.some(button => button.dataset.size === '14+')) selection = '14';
        if (!buttons.some(button => button.dataset.size === selection && !button.hidden)) selection = 'all';
        currentPage = Math.max(1, Math.floor(Number(url.searchParams.get('awb_page')) || 1));
      }
      function render(updateUrl) {
        if (!loaded) return;
        const matches = products.filter(({sizes}) => selection === 'all' || sizes.some(n => {
          if (selection === '12+') return n >= 12;
          if (selection === '14+') return n >= 14;
          if (selection === '16+') return n >= 16;
          return selection.split('–').map(Number).includes(n);
        }));
        const pages = Math.max(1, Math.ceil(matches.length / pageSize));
        currentPage = Math.min(currentPage, pages);
        grid.replaceChildren(...matches.slice((currentPage-1)*pageSize, currentPage*pageSize).map(product => product.card));
        grid.hidden = matches.length === 0;
        results.textContent = matches.length + ' ' + shop.querySelector('[data-result-label]').textContent + (selection === 'all' ? '' : ' · ' + selection + ' US');
        empty.hidden = matches.length !== 0;
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.size === selection)));
        nav.hidden = pages <= 1;
        nav.querySelector('[data-previous]').disabled = currentPage === 1;
        nav.querySelector('[data-next]').disabled = currentPage === pages;
        nav.querySelector('[data-page-label]').textContent = currentPage + ' / ' + pages;
        if (updateUrl) {
          const url = new URL(location.href);
          url.searchParams.delete('page');
          if (selection === 'all') url.searchParams.delete('awb_size'); else url.searchParams.set('awb_size', selection);
          if (currentPage === 1) url.searchParams.delete('awb_page'); else url.searchParams.set('awb_page', currentPage);
          history.pushState({}, '', url);
        }
      }
      async function getPage(page) {
        const url = new URL(location.href);
        url.searchParams.set('page', page);
        url.searchParams.set('sections', shop.dataset.sectionId);
        url.searchParams.delete('awb_size');
        url.searchParams.delete('awb_page');
        const response = await fetch(url, {credentials:'same-origin', signal:AbortSignal.timeout(20000)});
        if (!response.ok) throw new Error('Collection request failed');
        const json = await response.json();
        const html = json[shop.dataset.sectionId];
        if (typeof html !== 'string') throw new Error('Collection section missing');
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const section = doc.querySelector('[data-awb-shop]');
        if (!section || section.dataset.mode !== shop.dataset.mode) throw new Error('Collection mismatch');
        return section;
      }
      async function loadAll() {
        loaded = false;
        grid.hidden = true;
        empty.hidden = true;
        nav.hidden = true;
        error.hidden = true;
        shop.setAttribute('aria-busy', 'true');
        results.textContent = shop.querySelector('[data-loading-label]').textContent;
        buttons.forEach(button => {button.disabled = true;});
        try {
          const first = initial.querySelector('[data-source]').dataset.page === '1' ? initial : await getPage(1);
          const meta = first.querySelector('[data-source]').dataset;
          const total = Number(meta.total), pages = Math.max(1, Number(meta.pages));
          if (!Number.isInteger(total) || total > 25000 || !Number.isInteger(pages)) throw new Error('Unsupported collection size');
          const seen = new Set(), cards = [];
          function collect(section, page) {
            const info = section.querySelector('[data-source]');
            if (!info || Number(info.dataset.page) !== page || Number(info.dataset.total) !== total || Math.max(1,Number(info.dataset.pages)) !== pages) throw new Error('Collection changed');
            section.querySelectorAll('[data-source-product]').forEach(item => {
              const id = item.dataset.sourceProduct;
              if (seen.has(id)) throw new Error('Duplicate product page');
              seen.add(id);
            });
            section.querySelectorAll('[data-awb-product]').forEach(card => cards.push(card));
          }
          collect(first, 1);
          for (let page = 2; page <= pages; page++) collect(await getPage(page), page);
          if (seen.size !== total) throw new Error('Incomplete collection');
          products = cards.map(card => ({card, sizes:[...card.querySelectorAll('[data-size-value]')].map(el => awbUsSize(el.dataset.sizeName, el.dataset.sizeValue)).filter(n => n !== null)}));
          shop.dataset.loadedProducts = String(seen.size);
          loaded = true;
          buttons.forEach(button => {
            const group = button.dataset.size;
            const hasMatches = shop.dataset.mode.startsWith('lastpairs_') || group === 'all' || products.some(({sizes}) => sizes.some(n => group.endsWith('+') ? n >= Number(group.slice(0,-1)) : group.split('–').map(Number).includes(n)));
            button.hidden = !hasMatches;
            button.disabled = !hasMatches;
          });
          const panel = shop.querySelector('.awb-size-panel');
          if (panel) panel.hidden = !buttons.some(button => button.dataset.size !== 'all' && !button.hidden);
          readLocation();
          render(false);
        } catch (e) {
          results.textContent = '';
          error.hidden = false;
        } finally {
          shop.setAttribute('aria-busy', 'false');
        }
      }
      buttons.forEach(button => button.addEventListener('click', () => {selection = button.dataset.size; currentPage = 1; render(true);}));
      nav.querySelector('[data-previous]').addEventListener('click', () => {currentPage--; render(true); results.scrollIntoView({block:'start'});});
      nav.querySelector('[data-next]').addEventListener('click', () => {currentPage++; render(true); results.scrollIntoView({block:'start'});});
      shop.querySelector('[data-retry]').addEventListener('click', loadAll);
      window.addEventListener('popstate', () => {readLocation(); render(false);});
      loadAll();
    });
  }
  setupAwbShop();
  document.addEventListener('shopify:section:load', setupAwbShop);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  } catch(e) { console.error(e); }
})();
})();
